module.exports = __webpack_public_path__ + "static/media/star.c9bbe2b8.png";